import { Button } from '@/components/ui/button';

const planPoints = ['Basic API Access', 'Email Support'];

export const FreePlanCard = () => {
  return (
    <div className="w-full bg-primary-gradient p-7 rounded-[20px] mb-[30px] md:py-5 md:pr-5 md:pl-10 sm:py-4 sm:pr-4 sm:pl-6">
      <div className="w-full flex items-center justify-between gap-5 flex-wrap md:flex-nowrap">
        <div className="space-y-1.5 mb-4 md:mb-0">
          <p className="text-xl font-dmSans text-white leading-none sm:text-lg">
            Basic
          </p>
          <h2 className="text-[32px] font-semibold font-dmSans text-white leading-none sm:text-[28px]">
            Free
          </h2>
          <p className="text-base font-dmSans text-white leading-none sm:text-sm">
            Up to 100 records/month
          </p>
        </div>

        <ul className="w-full md:w-auto">
          <li className="text-base font-dmSans text-white leading-[22px] mb-2 flex items-center gap-[15px] sm:text-sm sm:leading-[18px] sm:gap-[10px]">
            <svg
              width="20"
              height="14"
              viewBox="0 0 20 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.99128 14C6.73979 14 6.4883 13.9038 6.29673 13.7122L0.279404 7.69467C-0.104853 7.3106 -0.104853 6.68963 0.279404 6.30556C0.663476 5.92149 1.28426 5.92149 1.66851 6.30556L6.99128 11.6283L18.3317 0.288054C18.7158 -0.0960182 19.3366 -0.0960182 19.7208 0.288054C20.1049 0.672265 20.1049 1.29309 19.7208 1.67735L7.68602 13.7122C7.59487 13.8035 7.48658 13.876 7.36735 13.9254C7.24813 13.9748 7.12033 14.0001 6.99128 14Z"
                fill="white"
              />
            </svg>
            100 records/month <br />
            (Reset Monthly)
          </li>
          {planPoints.map((point, index) => (
            <li
              key={index}
              className="text-base font-dmSans text-white leading-[22px] mb-2 flex items-center gap-[15px] sm:text-sm sm:leading-[18px] sm:gap-[10px]"
            >
              <svg
                width="20"
                height="14"
                viewBox="0 0 20 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99128 14C6.73979 14 6.4883 13.9038 6.29673 13.7122L0.279404 7.69467C-0.104853 7.3106 -0.104853 6.68963 0.279404 6.30556C0.663476 5.92149 1.28426 5.92149 1.66851 6.30556L6.99128 11.6283L18.3317 0.288054C18.7158 -0.0960182 19.3366 -0.0960182 19.7208 0.288054C20.1049 0.672265 20.1049 1.29309 19.7208 1.67735L7.68602 13.7122C7.59487 13.8035 7.48658 13.876 7.36735 13.9254C7.24813 13.9748 7.12033 14.0001 6.99128 14Z"
                  fill="white"
                />
              </svg>
              {point}
            </li>
          ))}
        </ul>

        <Button className="bg-white px-[70px] text-[22px] w-full lg:w-auto hover:bg-white/90 h-[60px] rounded-full sm:px-[50px] sm:text-[18px] sm:h-[50px]">
          <span className="gradient-text text-transparent bg-clip-text font-medium">
            Get Started
          </span>
        </Button>
      </div>
    </div>
  );
};
